// jQuery Safe Loading Wrapper
// This script ensures jQuery-dependent code only runs when jQuery is available
(function() {
  // Store a reference to any existing jQuery
  var _jQuery = window.jQuery || null;
  
  // Create a queue for jQuery-dependent functions
  var jQueryReadyQueue = [];
  
  // Function to safely execute code when jQuery is available
  window.runWhenJQueryReady = function(callback) {
    if (window.jQuery) {
      // If jQuery is already available, execute immediately
      callback(window.jQuery);
    } else {
      // Otherwise queue the callback for later execution
      console.log('Queueing function to run when jQuery is available');
      jQueryReadyQueue.push(callback);
    }
  };
  
  // Function to process the queue when jQuery becomes available
  function processJQueryReadyQueue() {
    console.log('jQuery is now available, processing queued functions');
    while (jQueryReadyQueue.length > 0) {
      var callback = jQueryReadyQueue.shift();
      try {
        callback(window.jQuery);
      } catch (error) {
        console.error('Error executing queued jQuery function:', error);
      }
    }
  }
  
  // Set up a watcher to detect when jQuery becomes available
  function checkForjQuery() {
    if (window.jQuery && window.jQuery !== _jQuery) {
      // jQuery is now available and different from our stored reference
      processJQueryReadyQueue();
      // Update our reference
      _jQuery = window.jQuery;
    } else {
      // Check again after a short delay
      setTimeout(checkForjQuery, 50);
    }
  }
  
  // Start checking for jQuery
  checkForjQuery();
  
  // Also check when the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (window.jQuery) {
        processJQueryReadyQueue();
      }
    });
  }
  
  // Final check when everything is loaded
  window.addEventListener('load', function() {
    if (window.jQuery) {
      processJQueryReadyQueue();
    }
  });
})();
